import { calcAuth0Audience, calcAuth0RedirectUri } from './calcConfig';

export const AUTH0_SCOPE = 'openid profile email';

/** Shared Auth0 authorizationParams for login + silent token refresh. */
export function calcAuth0AuthorizationParams(extra = {}) {
  const audience = calcAuth0Audience();
  return {
    redirect_uri: calcAuth0RedirectUri(),
    scope: AUTH0_SCOPE,
    ...(audience ? { audience } : {}),
    ...extra,
  };
}

/** True while Auth0 is completing the OAuth redirect (code in query string). */
export function isAuth0RedirectCallback() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.has('code') && params.has('state');
}
